var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alltitlStyle"},[_c('h2',{class:['title', _vm.titleClass]},[_c('span',[_vm._v(_vm._s(_vm.title))])]),(_vm.titleP)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.titleP)}}):_vm._e(),(_vm.subTitle)?_c('h2',{staticClass:"subTitle"},[_c('span',[_vm._v(_vm._s(_vm.subTitle))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }